export function loadGroupTypes(detail) {
  return {
    type: 'LOAD_GROUP_TYPES',
    detail,
  };
}
